import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
// remove associations positioning here,
// eventually remove it from the baked in render method to make this cleaner
const TrayWrapper = styled.div.withConfig({
  displayName: "RenderTray__TrayWrapper"
})(["flex-grow:", ";display:flex;justify-content:", ";.associations-positioning-wrapper{position:relative !important;right:auto !important;margin:", " !important;}"], ({
  $flexGrow
}) => $flexGrow, ({
  $justifyContent
}) => $justifyContent, ({
  theme
}) => theme.space['0']);
/** Configuration for the Render Tray capability (custom content below editor) */

const RenderTrayPassthrough = ({
  renderTray,
  flexGrow = 1,
  justifyContent = 'flex-end'
}) => {
  // @bend-expect trellis-tokenized
  return /*#__PURE__*/_jsx(TrayWrapper, {
    $flexGrow: flexGrow,
    $justifyContent: justifyContent,
    children: renderTray && renderTray({})
  });
};
export default RenderTrayPassthrough;